import { Switch, styled } from "@material-ui/core";
import __ from "lodash";

const supportedIcons = {
  edit: `d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"`,
  visibility: `d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"`
}


const IconSwitch = (props) => {
  const {
    children,
    icons,
    colors,
    backgroundColors,
    ...switchProps
  } = props;

  if (!icons || !Array.isArray(icons) || icons.length !== 2) {
    throw new Error("IconSwitch requires a property of Icons as an Array of length 2, values can be name of a supported icon or an svg path");
  }
  if (colors && (!Array.isArray(colors) || colors.length !== 2)) {
    throw new Error("The IconSwitch colors property has to be an Array of length 2, values should be strings");
  }
  if (backgroundColors && (!Array.isArray(backgroundColors) || backgroundColors.length !== 2)) {
    throw new Error("The IconSwitch backgroundColors property has to be an Array of length 2, values should be strings");
  }

  let offIcon = icons[0];
  let onIcon = icons[1];

  if (__.has(supportedIcons,offIcon)){
    offIcon = supportedIcons[offIcon];
  }
  if (__.has(supportedIcons,onIcon)){
    onIcon = supportedIcons[onIcon];
  }

  let offColor = null;
  let onColor = null;
  if (colors) {
    offColor = colors[0];
    onColor = colors[1];
  }

  let offBgColor = null;
  let onBgColor = null;
  if (backgroundColors) {
    offBgColor = backgroundColors[0];
    onBgColor = backgroundColors[1];
  }


  const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb': {
          backgroundColor: onBgColor?onBgColor:theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
        },
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
            `${onColor?onColor:'#fff'}`,
          )}" ${onIcon}/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: offBgColor?offBgColor:theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
      width: 32,
      height: 32,
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          `${offColor?offColor:'#fff'}`,
        )}" ${offIcon}/></svg>')`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
    },
  }));

  return (<StyledSwitch {...switchProps}>{children}</StyledSwitch>)
}

export default IconSwitch;